<div [ngClass]="{ 'tw-container laptop:tw-w-[720px] laptop:tw-pt-[18px] tablet:tw-pt-0': isAddItemPage,
  'tw-bg-white': !isAddItemPage
 }">
  <form (ngSubmit)="handleSubmit()" [formGroup]="form">
    <div
      [ngClass]="
        isAddItemPage
          ? 'tw-bg-white tw-sml-border tw-rounded-2xl tw-px-4 tw-py-5 tablet:tw-p-8 tw-mb-3'
          : 'itemBlock'
      "
    >
      <!-- <div class="tw-block">
        <h4
          class="tw-flex tw-text-grey-950 tw-items-center tw-justify-between tw-gap-1 tw-text-lg tw-font-bold"
        >
          <span>Item Details</span>
          <button
            type="button"
            class="tw-p-1"
            (click)="isItemDetailVisible = !isItemDetailVisible"
          >
            <i-icon
              [name]="isItemDetailVisible ? 'chevron-up' : 'chevron-down'" class="tw-block"
              [height]="'tw-h-5'"
              [width]="'tw-w-5'"
            ></i-icon>
          </button>
        </h4>
        <p class="tw-text-grey-600 tw-text-xs tw-font-normal tw-leading-[18px] tablet:tw-text-base tablet:tw-leading-5">
          Add basic details about the item you want to create right now
        </p>
      </div> -->
      <div [hidden]="!isItemDetailVisible" [@slideUpDown]>
        <sml-item-basic-detail
          [form]="itemDetailForm"
          [listingTypeId]="listingTypeId"
          [isFromCommunityStories]="isFromCommunityStories"
          [isVolunteerActivity]="(campaignType ? campaignType : typeCampaign()) === campaignStatus['Volunteer Activity']"
          [campaignType]="campaignType ? campaignType : typeCampaign()"
        >
        
        <ng-container dates *ngIf="showRegistrationDate || this.typeCampaign()===campaignStatus['Registration']" >
          <div class="sml-control-group tw-col-span-2 tw-pb-6 tw-border-b md:tw-border-mercury-200 md:tw-border-dashed">
            <sml-item-dates
            [isEditItem]="isEditItem"
            [isDonated]="isDonated" 
            (endAPM)="EndAPM($event)"
            (startAPM)="StartAPM($event)"
            [ItemDates]="itemDatesForm"
            [setStartTimeAPM]="startAPMPatch"
            [isNewItem]="isNewItem"
            [setEndTimeAPM]="endAPMPatch"
            [timeZoneMandatory]="showTimeZone"
            [isRegistrationItem]="isRegistrationItem || this.typeCampaign()===campaignStatus['Registration']"
            ></sml-item-dates>
          </div>
        </ng-container>

      </sml-item-basic-detail>
      </div>
    </div>
    @if((showDate || this.typeCampaign()===campaignStatus['Volunteer Activity'])){
 
      <div
      [ngClass]="
        isAddItemPage
          ? 'tw-bg-white tw-sml-border tw-rounded-2xl tw-px-4 tw-py-5 tablet:tw-p-8 tw-mb-3'
          : 'itemBlock'
      "
    >
      <!-- <div class="tw-block">
        <h4
          class="tw-flex tw-text-grey-950 tw-items-center tw-justify-between tw-gap-1 tw-text-lg tw-font-bold"
        >
          <span>Dates</span>
          <button
            type="button"
            class="tw-p-1"
            (click)="isItemDateVisible = !isItemDateVisible"
          >
            <i-icon
              [name]="isItemDateVisible ? 'chevron-up' : 'chevron-down'" class="tw-block"
              [height]="'tw-h-5'"
              [width]="'tw-w-5'"
            ></i-icon>
          </button>
        </h4>
        <p class="tw-text-grey-600 tw-text-xs tw-font-normal tw-leading-[18px] tablet:tw-text-base tablet:tw-leading-5">
          Add basic details about the event’s dates      
          </p>
      </div> -->
      <div [hidden]="!isItemDateVisible" [@slideUpDown]>
        <sml-item-dates
        [isEditItem]="isEditItem"
        [isDonated]="isDonated" 
        (endAPM)="EndAPM($event)"
        (startAPM)="StartAPM($event)"
        [ItemDates]="itemDatesForm"
        [setStartTimeAPM]="startAPMPatch"
        [isNewItem]="isNewItem"
        [setEndTimeAPM]="endAPMPatch"
        [timeZoneMandatory]="showTimeZone"
        [isRegistrationItem]="isRegistrationItem || this.typeCampaign()===campaignStatus['Registration']"
        ></sml-item-dates>
      </div>
    </div>
    }
    @if (!isDonationSelected ) {
      <ng-container *ngIf="isTypeVoulunteer">
      <div
        [ngClass]="
          isAddItemPage
            ? 'tw-bg-white tw-sml-border tw-rounded-2xl tw-px-4 tw-py-5 tablet:tw-p-8 tw-mb-3'
            : 'itemBlock'
        "
      >
        <!-- <div class="tw-block">
          <h4
            class="tw-flex tw-text-grey-950 tw-items-center tw-justify-between tw-gap-1 tw-text-lg tw-font-bold"
          >
            <span>{{isTypeVoulunteer && listingTypeId === itemListingTypeEnum.Multiple ? 'Participation Details' : 'Pricing'}}</span>
            <button
              type="button"
              class="tw-p-1"
              (click)="isItemPriceVisible = !isItemPriceVisible"
            >
              <i-icon
                [name]="isItemPriceVisible ? 'chevron-up' : 'chevron-down'"
                class="tw-block"
                [height]="'tw-h-5'"
                [width]="'tw-w-5'"
              ></i-icon>
            </button>
          </h4>
          <p class="tw-text-grey-600 tw-text-xs tw-font-normal tw-leading-[18px] tablet:tw-text-base tablet:tw-leading-5">
            {{isTypeVoulunteer && listingTypeId === itemListingTypeEnum.Multiple ? 'Display the number of volunteers needed or add shifts if applicable.' : ' Set a price for your item & give your donor the option to pay online.'}}
           
          </p>
        </div> -->
        <div [hidden]="!isItemPriceVisible" [@slideUpDown]>
          <sml-item-pricing
            [form]="itemPriceForm"
            [listingTypeId]="listingTypeId"
            [isEditItem]="isEditItem"
            [campaignType]="campaignType ? campaignType : typeCampaign()"
            [volunteerShifts]="getVolunteerShifts()"
            (volunteerShiftsChange)="setVolunteerShifts($event)"
            [showShiftError]="showShiftsError"
            [isDonated]="isDonated"
            (switchPriceRange)="switchPriceRange($event)"
            [drawerSize]="drawerSize"
            (timeZoneMandatory)="timeZoneMandatory($event)"
            [disableShiftOptions]="disableShiftOptions"
            (removeShiftError)="removeShiftError($event)"
            [isNewFlag]="data?.isNew || !data?.id ? true : false"
          >
          </sml-item-pricing>
        </div>
      </div>
    </ng-container>
    }
    @if (!isDonationSelected ) {
      <ng-container *ngIf="!isTypeVoulunteer">
      <div
        [ngClass]="
          isAddItemPage
            ? 'tw-bg-white tw-sml-border tw-rounded-2xl tw-px-4 tw-py-5 tablet:tw-p-8 tw-mb-3'
            : 'itemBlock'
        "
      >
        <!-- <div class="tw-block">
          <h4
            class="tw-flex tw-text-grey-950 tw-items-center tw-justify-between tw-gap-1 tw-text-lg tw-font-bold"
          >
            <span>{{isTypeVoulunteer && listingTypeId === itemListingTypeEnum.Multiple ? 'Participation Details' : 'Pricing'}}</span>
            <button
              type="button"
              class="tw-p-1"
              (click)="isItemPriceVisible = !isItemPriceVisible"
            >
              <i-icon
                [name]="isItemPriceVisible ? 'chevron-up' : 'chevron-down'"
                class="tw-block"
                [height]="'tw-h-5'"
                [width]="'tw-w-5'"
              ></i-icon>
            </button>
          </h4>
          <p class="tw-text-grey-600 tw-text-xs tw-font-normal tw-leading-[18px] tablet:tw-text-base tablet:tw-leading-5">
            {{isTypeVoulunteer && listingTypeId === itemListingTypeEnum.Multiple ? 'Display the number of volunteers needed or add shifts if applicable.' : ' Set a price for your item & give your donor the option to pay online.'}}
           
          </p>
        </div> -->
        <div [hidden]="!isItemPriceVisible" [@slideUpDown]>
          <sml-item-pricing
            [form]="itemPriceForm"
            [listingTypeId]="listingTypeId"
            [isEditItem]="isEditItem"
            [campaignType]="campaignType ? campaignType : typeCampaign()"
            [volunteerShifts]="getVolunteerShifts()"
            (volunteerShiftsChange)="setVolunteerShifts($event)"
            (switchPriceRange)="switchPriceRange($event)"
            [showShiftError]="showShiftsError"
            [isDonated]="isDonated"
            [drawerSize]="drawerSize"
            (timeZoneMandatory)="timeZoneMandatory($event)"
            [disableShiftOptions]="disableShiftOptions"
          >
          </sml-item-pricing>
        </div>
      </div>
    </ng-container>

    }
    <div
    [ngClass]="
      isAddItemPage
        ? 'tw-bg-white tw-sml-border tw-rounded-2xl tw-px-4 tw-py-5 tablet:tw-p-8 tw-mb-3'
        : 'itemBlock'
    "
    *ngIf="!(isFromCommunityStories || isDonated || isDonationSelected)"
  >
    <!-- <div class="tw-block">
      <h4
        class="tw-flex tw-text-grey-950 tw-items-center tw-justify-between tw-gap-1 tw-text-lg tw-font-bold"
      >
        <span>Participation Form</span>
        <button
          type="button"
          class="tw-p-1"
          (click)="isParticipationVisible = !isParticipationVisible"
        >
          <i-icon
            [name]="isParticipationVisible ? 'chevron-up' : 'chevron-down'"
            class="tw-block"
            [height]="'tw-h-5'"
            [width]="'tw-w-5'"
          ></i-icon>
        </button>
      </h4>
      <p class="tw-text-grey-600 tw-text-xs tw-font-normal tw-leading-[18px] tablet:tw-text-base tablet:tw-leading-5">
        Select which form option you would like to use to gather details about your donors and volunteers.
      </p>
    </div> -->
    <div [hidden]="!isParticipationVisible" [@slideUpDown]>
      <sml-item-participation [participationForm]="itemParticipationForm" [customForms]="customForms" [isFromCommunityStories]="isFromCommunityStories" [formOverviewModel]="formOverviewModel"
      [isVolunteer]="(campaignType ? campaignType : typeCampaign()) === campaignStatus['Volunteer Activity']" >

      </sml-item-participation>
    </div>

  </div>
  

  


    <!-- <div
    [ngClass]="
      isAddItemPage
        ? 'tw-bg-white tw-sml-border tw-rounded-2xl tw-px-4 tw-py-5 tablet:tw-p-8 tw-mb-3'
        : 'itemBlock'
    "
  >
    <div class="tw-block">
      <h4
        class="tw-flex tw-text-grey-950 tw-items-center tw-justify-between tw-gap-1 tw-text-lg tw-font-bold"
      >
        <span>Location</span>
        <button
          type="button"
          class="tw-p-1"
          (click)="isItemLocationVisible = !isItemLocationVisible"
        >
          <i-icon
            [name]="isItemLocationVisible ? 'chevron-up' : 'chevron-down'"
            class="tw-block"
            [height]="'tw-h-5'"
            [width]="'tw-w-5'"
          ></i-icon>
        </button>
      </h4>
      <p class="tw-text-grey-600 tw-text-xs tw-font-normal tw-leading-[18px] tablet:tw-text-base tablet:tw-leading-5">
        Add details about location of this item
      </p>
    </div>
    <div [hidden]="!isItemLocationVisible" [@slideUpDown]>
      <sml-item-location [form]="itemLocationForm" [campaignType]="campaignType ? campaignType : typeCampaign()" [isDonated]="isDonated"></sml-item-location>
    </div>

  </div>
   -->
  <div
  [ngClass]="
    isAddItemPage
      ? 'tw-bg-white tw-sml-border tw-rounded-2xl tw-px-4 tw-py-5 tablet:tw-p-8 tw-mb-3'
      : 'itemBlock'
  "
>
  <!-- <div class="tw-block">
    <h4
      class="tw-flex tw-text-grey-950 tw-items-center tw-justify-between tw-gap-1 tw-text-lg tw-font-bold"
    >
      <span>Uploads</span>
      <button
        type="button"
        class="tw-p-1"
        (click)="isItemUploadVisible = !isItemUploadVisible"
      >
        <i-icon
          [name]="isItemUploadVisible ? 'chevron-up' : 'chevron-down'"
          class="tw-block"
          [height]="'tw-h-5'"
          [width]="'tw-w-5'"
        ></i-icon>
      </button>
    </h4>
    <p class="tw-text-grey-600 tw-text-xs tw-font-normal tw-leading-[18px] tablet:tw-text-base tablet:tw-leading-5">
      Upload photos you would like to showcase for this item photo gallery
      and all the documents related to this item under item document
    </p>
  </div> -->
  <div [hidden]="!isItemUploadVisible" [@slideUpDown]>
    <sml-item-upload
      [galleryBlob]="data?.itemDetails?.gallaryBlob ?? '[]'"
      [documentBlob]="data?.itemDetails?.documentsBlob ?? '[]'"
      (uploadedFiles)="uploadedFiles($event)"
    ></sml-item-upload>
  </div>
</div>
 
      <div
        [ngClass]="
          isAddItemPage
            ? 'tw-bg-white tw-sml-border tw-rounded-2xl tw-px-4 tw-py-5 tablet:tw-p-8 tw-mb-3'
            : 'itemBlock'
        "
        *ngIf="isDonationSelected && listingTypeId === itemListingTypeEnum.Single && !isTypeVoulunteer"
      >
        <!-- <div class="tw-block tw-mb-5">
          <h4
            class="tw-flex tw-text-grey-950 tw-items-center tw-justify-between tw-gap-1 tw-text-lg tw-font-bold"
          >
            <span>Donation + QR Plaque </span>
            <button
              type="button"
              class="tw-p-1"
              (click)="isDonationVisible = !isDonationVisible"
            >
              <i-icon
                [name]="isDonationVisible ? 'chevron-up' : 'chevron-down'"
                class="tw-block"
                [height]="'tw-h-5'"
                [width]="'tw-w-5'"
              ></i-icon>
            </button>
          </h4>
          <p class="tw-text-grey-600 tw-text-xs tw-font-normal tw-leading-[18px] tablet:tw-text-base tablet:tw-leading-5">
            Add details about donation and attach available QR plaque to this
            item
          </p>
        </div> -->
        <div [hidden]="!isDonationVisible" [@slideUpDown]>
          <sml-item-donation
          [campaignType]="campaignType ? campaignType : typeCampaign()"
            [form]="itemDonationForm"
            [communityPlaquesData]="communityPlaquesData"
          ></sml-item-donation>
        </div>
      </div>


        <div *ngIf="!isDonated"
  [ngClass]="
    isAddItemPage
      ? 'tw-bg-white tw-sml-border tw-rounded-2xl tw-px-4 tw-py-5 tablet:tw-p-8 tw-mb-3'
      : 'itemBlock'
  "
>
  @if(showCustomizeEmailSection){
     <div [formGroup]="notificationForm">
  <div class="tw-bg-[#F8F8F8] tw-p-2 tw-rounded-lg">
    <div class="tw-flex tw-flex-col tw-gap-2">
      <div class="tw-flex tw-items-center tw-justify-between">
        <div class="tw-flex tw-items-center tw-gap-1">
          <label for="guidelines"
            class="tw-text-[#041519] tw-text-[14px] tw-font-bold tw-leading-[20px] tw-capitalize tw-not-italic"
            id="customize-email-heading">{{
            notificationString.CUSTOMIZE_EMAIL_TEXT }}
          </label>
          <i-icon [name]="'info'" class="!tw-w-4 !tw-h-4 tw-text-grey-950" [smlTooltip]="'This message will be included in the confirmation email your participants receive. Add instructions or further details!'" [placement]="'bottom'" mode="always"></i-icon>
        </div>
        <i-icon (click)="deleteCustomEmail()" [name]="'trash'"
          class="!tw-w-[18px] !tw-h-[18px] tw-cursor-pointer"></i-icon>
      </div>
      <sml-text-editor [placeholderText]="notificationString.CUSTOMIZE_EMAIL_EDITOR_PLACEHOLDER"
        [showCharacterLimitText]="false" [editorHeight]="true" formControlName="itemCustomMessage"></sml-text-editor>
    </div>
  </div>
</div>
  } @else {
    <button [smlButton]="'secondary'" type="button" [size]="'md'" [rounded]="'md'"
      class="tw-max-w-[257px] !tw-h-[46px] !tw-py-3 !tw-pl-2 !tw-pr-4" (click)="showCustomizeEmailSection = true">
      <div class="tw-flex tw-items-center tw-gap-1 tw-text-primary-700 tw-text-sm">
        <i-icon [name]="'customize-email-icon'" class="!tw-w-[16px] !tw-h-[13px]"></i-icon>
        <div>Customize Email for Participants</div>
      </div>
    </button>
  }
   </div>




      <div
      [ngClass]="
        isAddItemPage
          ? 'tw-bg-white tw-sml-border tw-rounded-2xl tw-px-4 tw-py-5 tablet:tw-p-8 tw-mb-3'
          : 'itemBlock'
      "
      >
      <!-- <div class="tw-block">
        <h4
          class="tw-flex tw-text-grey-950 tw-items-center tw-justify-between tw-gap-1 tw-text-lg tw-font-bold"
        >
          <span>Post Type</span>
          <button
            type="button"
            class="tw-p-1"
            (click)="isItemUploadVisible = !isItemUploadVisible"
          >
            <i-icon
              [name]="isItemUploadVisible ? 'chevron-up' : 'chevron-down'"
              class="tw-block"
              [height]="'tw-h-5'"
              [width]="'tw-w-5'"
            ></i-icon>
          </button>
        </h4>
        <p class="tw-text-grey-600 tw-text-xs tw-font-normal tw-leading-[18px] tablet:tw-text-base tablet:tw-leading-5">
          Upload photos you would like to showcase for this item photo gallery
          and all the documents related to this item under item document
        </p>
      </div> -->
      <div [hidden]="!isItemUploadVisible" [@slideUpDown]>
        <sml-item-visiblity [form]="itemVisiblityForm" [accessType]="data?.itemDetails?.accessType || (isArchived ? campaignAccessType['Archived'] : undefined )"></sml-item-visiblity>
      </div>
      </div>
  </form>
</div>
<!-- <div
 *ngIf="isLaptopView && !isCreateUrl"
  class="tw-sml-border !tw-border-primary-500 tw-items-center tw-rounded-lg tw-flex tw-gap-2 tw-bg-primary-100 tw-py-3 tw-pl-3 tw-pr-4 tw-absolute tw-top-[82px] tw-right-6"
>
  

  @if(listingTypeId === itemListingTypeEnum.Custom){
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.6801 4.87996C9.84748 4.87996 5.12007 9.60737 5.12007 15.44C5.12007 21.2725 9.84748 26 15.6801 26C21.5126 26 26.2401 21.2725 26.2401 15.44C26.2401 9.60737 21.5126 4.87996 15.6801 4.87996ZM3.20007 15.44C3.20007 8.54699 8.78711 2.95996 15.6801 2.95996C22.573 2.95996 28.1601 8.54699 28.1601 15.44C28.1601 22.3329 22.573 27.92 15.6801 27.92C8.78711 27.92 3.20007 22.3329 3.20007 15.44Z" fill="#106B8E"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0875 13.618C12.0875 11.9914 13.4057 10.6753 15.0302 10.6753H16.6716C18.1084 10.6753 19.2731 11.8399 19.2731 13.2767V13.3714C19.2731 13.9016 18.8433 14.3314 18.3131 14.3314C17.7829 14.3314 17.3531 13.9016 17.3531 13.3714V13.2767C17.3531 12.9003 17.0481 12.5953 16.6716 12.5953H15.0302C14.4653 12.5953 14.0076 13.0526 14.0076 13.618C14.0076 14.1824 14.4657 14.6407 15.0302 14.6407H16.4076C17.9894 14.6407 19.2744 15.9227 19.2744 17.5061C19.2744 19.0903 17.9898 20.3729 16.4076 20.3729H14.6889C13.2512 20.3729 12.0875 19.2061 12.0875 17.7702C12.0875 17.24 12.5173 16.8102 13.0476 16.8102C13.5778 16.8102 14.0076 17.24 14.0076 17.7702C14.0076 18.1476 14.3135 18.4529 14.6889 18.4529H16.4076C16.9302 18.4529 17.3544 18.0291 17.3544 17.5061C17.3544 16.9847 16.9306 16.5607 16.4076 16.5607H15.0302C13.4053 16.5607 12.0875 15.2429 12.0875 13.618Z" fill="#106B8E"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.685 9.30029C16.2152 9.30029 16.645 9.7301 16.645 10.2603V11.6315C16.645 12.1617 16.2152 12.5915 15.685 12.5915C15.1548 12.5915 14.725 12.1617 14.725 11.6315V10.2603C14.725 9.7301 15.1548 9.30029 15.685 9.30029ZM15.685 18.4594C16.2152 18.4594 16.645 18.8893 16.645 19.4194V20.6288C16.645 21.159 16.2152 21.5888 15.685 21.5888C15.1548 21.5888 14.725 21.159 14.725 20.6288V19.4194C14.725 18.8893 15.1548 18.4594 15.685 18.4594Z" fill="#041519"/>
  </svg>
}
@else if(listingTypeId === itemListingTypeEnum.Single || listingTypeId === itemListingTypeEnum.Multiple) {
  <i-icon
  [name]="itemIcon"
  class="!tw-w-8 !tw-h-8 tw-text-primary-700"
></i-icon>
}
    

 <div class="tw-flex tw-flex-col">
    <div class="tw-text-primary-700 tw-font-bold tw-text-sm tw-leading-[22px]">
      @if(this.isVolunteerEvent){
        {{ itemsStrings.Volunteer_TEXT }}
      }
      @else if(listingTypeId === itemListingTypeEnum.Single){
        {{ itemsStrings.SINGLE_QUANTITY_TEXT }}
      }
      @else if(listingTypeId === itemListingTypeEnum.Multiple && !this.isVolunteerEvent){
        {{ itemsStrings.MULTIPLE_QUANTITY_TEXT }}
      }
      @else if(listingTypeId === itemListingTypeEnum.Custom){
        {{ itemsStrings.CUSTOM_PRICE_TEXT }}
      }
    </div>
    <div class="tw-text-primary-700 tw-text-xs tw-leading-[18px]">
      @if(this.isVolunteerEvent){
        {{ itemsStrings.Volunteer_SUBTEXT }}
      }
      @else if(listingTypeId === itemListingTypeEnum.Single){
        {{ itemsStrings.SINGLE_QUANTITY_SUBTEXT }}
      }
      @else if(listingTypeId === itemListingTypeEnum.Multiple && !this.isVolunteerEvent){
        {{ itemsStrings.MULTIPLE_QUANTITY_SUBTEXT }}
      }
      @else if(listingTypeId === itemListingTypeEnum.Custom){
        {{ itemsStrings.CUSTOM_PRICE_SUBTEXT }}
      }
    </div>
  </div> 
</div> -->
